var scope_0 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0752fc4a8860753dc862cd7beed397ff.js').default;
var scope_1 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_2 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/256c9599843243af6aa0bc6918a97f52.js').default;
var scope_3 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/46a3ee9b4e0ec88673f1d4cf89581822.js').default;
var scope_4 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/59596619fcc0270cebdb26bff233e0a3.js').default;
var scope_5 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7fdaf05d24f3cea8ac8714a77b2c56f1.js').default;
var scope_6 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8c68b487136a900be82198d1005ab187.js').default;
var scope_7 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/97def7592212c461fffd85e63279f6db.js').default;
var scope_8 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a8559f66e9e791a6bb6ce3c4c161c7ea.js').default;
var scope_9 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a85a85be43e040e579016980fc0b869b.js').default;
var scope_10 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ca8b0239fc303a7cddcaf4ba3339a5b4.js').default;
var scope_11 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f8b9731db5bad4c17b6d4edc3033a5ce.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11 )
    